"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorRenewalDriverDetailsWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var FalconAccordion_1 = require("../../../../components/FalconAccordion");
var moment = require("moment");
var commonFunctions_1 = require("../../../../commonFunctions");
var services_1 = require("@falcon/services");
var AnnualMotorRenewalDriverDetailsWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorRenewalDriverDetailsWidget, _super);
    function AnnualMotorRenewalDriverDetailsWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.vehicleDrivers = [];
        _this.maxAdditionalDrivers = 5;
        _this.state = {};
        _this.vehicleToRender = _this.props.interaction.vehicles[0];
        var allDrivers = [_this.props.interaction.policyHolder].concat(_this.props.interaction.additionalDrivers || []);
        if (_this.vehicleToRender.driverIds) {
            _this.vehicleDrivers = _this.vehicleToRender.driverIds
                .map(function (driverId) { return allDrivers.find(function (driver) { return driverId === driver.personId; }); })
                .filter(function (driver) { return driver !== undefined; });
        }
        return _this;
    }
    AnnualMotorRenewalDriverDetailsWidget.prototype.render = function () {
        var _this = this;
        var isAccordionOpen = this.props.interaction.uistate.referrerMtaJourney === services_1.INTERACTION_PROCESS_RENEWAL_CANCELLATION;
        return (React.createElement("div", { className: "section-panel text-center annual-motor-renewal driver-details-section" },
            React.createElement("div", { className: "mt-3 panel-detail-output-entity" },
                React.createElement(FalconAccordion_1.FalconAccordion, { isOpen: isAccordionOpen, togglePositionTop: true, toggleHidden: React.createElement("div", { className: "toggle d-flex justify-content-between align-items-center" },
                        React.createElement("span", null),
                        React.createElement("span", { className: "font-weight-bold text-center fs-18 toggle-title collapsed-title" }, "Driver(s) details"),
                        React.createElement("span", { className: "toggle-icon expand-icon" })), toggleShown: React.createElement("div", { className: "toggle toggle-show d-flex justify-content-between align-items-center" },
                        React.createElement("span", null),
                        React.createElement("span", { className: "font-weight-bold text-center fs-18 toggle-title" }, "Driver(s) details"),
                        React.createElement("span", { className: "toggle-icon collapse-icon" })) },
                    React.createElement("div", { className: "driver-details accordion-content grid-make-2-col icon-people-before" },
                        this.renderDriverDetailSections(),
                        this.vehicleDrivers.length < this.maxAdditionalDrivers &&
                            React.createElement("div", { className: "section grid-col-2 margin-bottom-24 padding-bottom-16" },
                                React.createElement("div", { className: "section-contents" },
                                    React.createElement("div", { className: "detail" },
                                        React.createElement("div", { className: "detail buttonLink margin-top-0 add-another-driver-btn", id: "add-another-driver}", "aria-label": "Add another driver", onClick: function () { return _this.navigateToAddDriver(); } },
                                            React.createElement("button", { type: "button", className: "btn btn-primary margin-top-32" }, "Add another driver"))))))))));
    };
    AnnualMotorRenewalDriverDetailsWidget.prototype.renderDriverDetailSections = function () {
        var _this = this;
        return this.vehicleDrivers.map(function (driver, index) { return (React.createElement("div", { key: index, className: "section" },
            React.createElement("div", { className: "section-contents" }, _this.renderDriverDetails(driver, index)))); });
    };
    AnnualMotorRenewalDriverDetailsWidget.prototype.renderDriverDetails = function (driver, index) {
        var _this = this;
        var _a;
        var isPolicyHolder = driver.personId === this.props.interaction.policyHolder.personId;
        var editDriverButtonId = index > 0 ? "vehicle-0-edit-additional-driver-" + index : "vehicle-0-edit-main-driver";
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "detail driver-name" },
                React.createElement("div", { className: "detail-key name" }, "".concat(driver.firstName, " ").concat(driver.lastName))),
            React.createElement("div", { className: "detail" },
                React.createElement("div", { className: "detail-key" }, "Date of birth:"),
                React.createElement("div", { className: "detail-value" }, moment(driver.dateOfBirth, moment.ISO_8601).format("D MMMM YYYY"))),
            ((_a = driver.dlnLookupData) === null || _a === void 0 ? void 0 : _a.dlnLookupCallSucess) &&
                React.createElement("div", { className: "detail" },
                    React.createElement("div", { className: "detail-key" }, "Driving licence number:"),
                    React.createElement("div", { className: "detail-value" }, driver.licence.number)),
            React.createElement("div", { className: "detail" },
                React.createElement("div", { className: "detail-key" }, "Claims in the last 5 years:"),
                this.renderClaims(driver)),
            React.createElement("div", { className: "detail" },
                React.createElement("div", { className: "detail-key" }, "Criminal convictions:"),
                React.createElement("div", { className: "detail-value" }, driver.hasUnspentCriminalConvictions ? "Yes" : "None")),
            this.renderMotoringConvictions(driver),
            isPolicyHolder && this.renderPolicyHolderDetails(),
            React.createElement("div", { className: isPolicyHolder ? "detail driver-actions" : "detail additional-driver-actions" },
                React.createElement("div", { className: "buttonLink edit-driver-btn ".concat(isPolicyHolder && "full-width"), id: editDriverButtonId, onClick: function () { return _this.navigateToEditCarDriver(index); } },
                    React.createElement("button", { type: "button", className: "btn btn-primary btn-margin-top" }, "Edit driver")),
                !isPolicyHolder && this.renderRemoveDriverButton(index))));
    };
    AnnualMotorRenewalDriverDetailsWidget.prototype.renderRemoveDriverButton = function (index) {
        var _this = this;
        return (React.createElement("div", { className: "buttonLink remove-driver-btn", id: "remove-driver-".concat(index), onClick: function () { return _this.navigateToRemoveCarDriver(index); } },
            React.createElement("button", { type: "button", className: "btn btn-white btn-margin-top" }, "Delete driver")));
    };
    AnnualMotorRenewalDriverDetailsWidget.prototype.renderMotoringConvictions = function (driver) {
        var _a;
        if ((_a = driver === null || driver === void 0 ? void 0 : driver.dlnLookupData) === null || _a === void 0 ? void 0 : _a.dlnLookupCallSucess) {
            return (React.createElement("div", { className: "detail" },
                React.createElement("div", { className: "detail-key" }, "Motoring convictions:"),
                React.createElement("div", { className: "detail-value" }, "As per your DVLA records")));
        }
        else {
            return (React.createElement("div", { className: "detail" },
                React.createElement("div", { className: "detail-key" }, "Motoring convictions:"),
                this.renderConvictionDetails(driver)));
        }
    };
    AnnualMotorRenewalDriverDetailsWidget.prototype.renderConvictionDetails = function (driver) {
        var _a;
        if (driver.hasConvictions && ((_a = driver.convictions) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            return driver.convictions.map(function (conviction, index) { return (React.createElement("div", { key: index, className: "detail-value" }, "".concat(conviction.convictionCode, ", ").concat((0, commonFunctions_1.formatDate)(conviction.convictionDate, "MMM YYYY")))); });
        }
        else {
            return React.createElement("div", { className: "detail-value" }, "None");
        }
    };
    AnnualMotorRenewalDriverDetailsWidget.prototype.renderClaims = function (driver) {
        var _a;
        if (driver.hasClaims && driver.numberOfClaims > 0 && ((_a = driver.claims) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            return driver.claims.map(function (claim, index) {
                return React.createElement("div", { key: index, className: "detail-value" },
                    (0, commonFunctions_1.resolveClaimType)(claim.claimType),
                    ", ",
                    (0, commonFunctions_1.formatDate)(claim.date, "MMM YYYY"));
            });
        }
        else {
            return React.createElement("div", { className: "detail-value" }, "None");
        }
    };
    AnnualMotorRenewalDriverDetailsWidget.prototype.renderPolicyHolderDetails = function () {
        var party = this.props.interaction.policyHolder;
        var addressComponents = (0, commonFunctions_1.getAddressLines)(party.address);
        var addressComponentsToRender = addressComponents.map(function (component, index) { return index === 0 ?
            React.createElement("span", { key: index, className: "detail-value" }, component) :
            React.createElement(React.Fragment, null,
                React.createElement("span", { key: index, className: "detail-value" },
                    ", ",
                    component)); });
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "detail" },
                React.createElement("div", { className: "detail-key" }, "No claim discount (NCD):"),
                React.createElement("div", { className: "detail-value" }, party.ncd.doNotDisclose ? "Protected" : "Not protected")),
            React.createElement("div", { className: "detail" },
                React.createElement("div", { className: "detail-key" }, "Years of no claim discount (NCD):"),
                React.createElement("div", { className: "detail-value" }, party.ncd.yearCount > 0 ? party.ncd.yearCount : "None")),
            React.createElement("div", { className: "detail address-detail" },
                React.createElement("div", { className: "detail-key" }, "Address:"),
                addressComponentsToRender),
            React.createElement("div", { className: "detail" },
                React.createElement("div", { className: "detail-key" }, "Email:"),
                React.createElement("div", { className: "detail-value" }, party.email)),
            React.createElement("div", { className: "detail" },
                React.createElement("div", { className: "detail-key" }, "Mobile number:"),
                React.createElement("div", { className: "detail-value" }, party.phoneNumber))));
    };
    AnnualMotorRenewalDriverDetailsWidget.prototype.navigateToEditCarDriver = function (driverIndex) {
        if (driverIndex === 0) {
            this.props.engine.navigate("presetDriverPolicyHolder", false);
        }
        else {
            this.props.engine.navigate("presetDriver".concat(driverIndex - 1), false);
        }
    };
    AnnualMotorRenewalDriverDetailsWidget.prototype.navigateToRemoveCarDriver = function (driverIndex) {
        this.props.engine.navigate("removeDriver".concat(driverIndex - 1, "EntryPage"), false);
    };
    AnnualMotorRenewalDriverDetailsWidget.prototype.navigateToAddDriver = function () {
        this.props.engine.navigate('addDriverPresetPage', false);
    };
    return AnnualMotorRenewalDriverDetailsWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualMotorRenewalDriverDetailsWidget = AnnualMotorRenewalDriverDetailsWidget;
//# sourceMappingURL=AnnualMotorRenewalDriverDetailsWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/renewal/AnnualMotorRenewalDriverDetailsWidget.js
// module id = 3189
// module chunks = 0